(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("colorcast", [], factory);
	else if(typeof exports === 'object')
		exports["colorcast"] = factory();
	else
		root["colorcast"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 